import './index.css';

import React from 'react';
import { createRoot } from 'react-dom/client';
import DittoProvider from 'ditto-react';
import { Provider } from 'mobx-react';
import { datadogRum } from '@datadog/browser-rum';

import { AppThemeProvider } from '@ui-library/tokens/themeContext';
import { stores } from '@stores/index';
import { ErrorBoundary } from '@lib/bugsnag';
import { ErrorPage } from '@components/common/errorPage';
import { IS_ADMIN_WEB_APP, DATADOG_APP_ID, DATADOG_CLIENT_TOKEN } from '@config';

import AppRouter from './auth/appRouter';
import GlobalStyles from './globalStyles';
import { loadSessionFromUrl } from './scripts';
import dittoData from './ditto';
import { configureIcons, ICONS_PATH } from '@rudderlabs/icons';

// PR previews serve the app from a sub-path (PUBLIC_URL); icons live under it too.
configureIcons({ baseUrl: `${process.env.PUBLIC_URL ?? ''}/${ICONS_PATH}` });

if (IS_ADMIN_WEB_APP) {
  loadSessionFromUrl();
}

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <AppThemeProvider>
    <GlobalStyles />
    <DittoProvider source={dittoData}>
      <ErrorBoundary FallbackComponent={ErrorPage}>
        <Provider {...stores}>
          <div className="App" data-version={process.env.REACT_APP_VERSION}>
            <AppRouter />
          </div>
        </Provider>
      </ErrorBoundary>
    </DittoProvider>
  </AppThemeProvider>,
);

datadogRum.init({
  applicationId: DATADOG_APP_ID,
  clientToken: DATADOG_CLIENT_TOKEN,
  site: 'datadoghq.com',
  service: 'control-plane-webapp',
  env: process.env.REACT_APP_ENV,
  version: process.env.REACT_APP_VERSION,
  sampleRate: 100,
  replaySampleRate: 100,
  trackInteractions: true,
  defaultPrivacyLevel: 'mask-user-input',
});
